import { ReactComponent as KalamaLockup } from 'src/assets/images/kalama-lockup-horizontal.svg'
import { KALAMA_HELP_ARTICLE_URL } from 'src/modules/brand/utils/kalama-notice'
import { FormattedText } from 'src/modules/core/components'
import type { KalamaNoticeBannerContentProps } from './kalama-notice-banner-content.interface'
import classes from './kalama-notice-banner-content.module.scss'

export function KalamaNoticeBannerContent({
  messageId,
  linkId,
  dismissId,
  testId,
  onDismiss,
}: KalamaNoticeBannerContentProps) {
  return (
    <div className={classes.banner} data-testid={testId}>
      <KalamaLockup className={classes.lockup} title="Kalama" />
      <FormattedText id={messageId} />
      <a className={classes.link} href={KALAMA_HELP_ARTICLE_URL} target="_blank" rel="noopener noreferrer">
        <FormattedText id={linkId} />
      </a>
      <button type="button" className={classes.dismiss} onClick={onDismiss}>
        <FormattedText id={dismissId} />
      </button>
    </div>
  )
}
